import { useEffect, useState } from "react";
import { TokenPanel } from "./TokenPanel";
import { TotpToken, TotpUri } from "./TotpUtils";

const DEFAULT_SECRET = '000000000000000000000000000000000000000';
export function TokenController()
{
  const d = () => new Date();
  const [now, setNow] = useState(d());
  const [secret, setSecret] = useState(DEFAULT_SECRET);

  useEffect(() =>
  {
    const timer = setInterval(() => setNow(d()), 1000);
    return () => clearInterval(timer);
  }, []);

  const setRandomSecret = () => setSecret(Math.random().toString().substring(2) + Math.random().toString().substring(2));
  const setDefaultSecret = () => setSecret(DEFAULT_SECRET);

  const uri = TotpUri({
    issuer: 'TotpFun',
    account: 'some.email@example.com',
    secret,
  });

  const secretOk = secret.length >= 20;

  const token = TotpToken({
    secret,
    now
  });

  return <TokenPanel
    now={now}
    secretOk={secretOk}
    secret={secret}
    setSecret={setSecret}
    setRandomSecret={setRandomSecret}
    setDefaultSecret={setDefaultSecret}
    token={token}
    uri={uri}
  />

}